export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9724.f075df98.jpg";